const CHANEL = 'chanel';
const DIOR = 'dior';
const SEPHORA_COLLECTION = 'sephora collection';

export {
    CHANEL, DIOR, SEPHORA_COLLECTION
};
